import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface ProjectManagementReportSearchParams {
  keyword?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getProjectManagementReports = async (params: ProjectManagementReportSearchParams = {}) => {
  const response = await axiosInstance.get("/projectmanagement/project-main/search", {
    params,
  });
  return response.data;
};
